import { Menu, ActionIcon } from '@mantine/core';
import { MoreVertical, RefreshCw, XCircle } from 'react-feather';

interface CheckinActionsMenuProps {
  onReschedule: () => void;
  onCancel: () => void;
}

export function CheckinActionsMenu({ onReschedule, onCancel }: CheckinActionsMenuProps) {
  return (
    <Menu shadow="md" width={160} position="bottom-end">
      <Menu.Target>
        <ActionIcon variant="subtle" color="gray" size="sm" aria-label="Check-in actions">
          <MoreVertical size={14} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item leftSection={<RefreshCw size={14} />} onClick={onReschedule}>
          Reschedule
        </Menu.Item>
        <Menu.Item leftSection={<XCircle size={14} />} color="red" onClick={onCancel}>
          Cancel
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
